import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS, SUCCESS_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'relative',
    zIndex: 2,
    height: 235,
    overflow: 'hidden',
    borderRadius: 8
  },
  buttonsWrapper: {
    marginLeft: 'auto',
    marginBottom: 'auto'
  },
  iconButton: {
    padding: 10,
    border: `1px solid ${GRAY_COLORS[300]}`,
    backgroundColor: 'white',
    borderRadius: 8,
    fontSize: 15,
    color: GRAY_COLORS[700]
  },
  icon: {
    borderRadius: 28,
    border: `8px solid ${PRIMARY_COLORS[50]}`,
    background: PRIMARY_COLORS[100],
    color: PRIMARY_COLORS[600],
    width: 48,
    height: 48,
    padding: 21,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 20
  },
  iconDownloaded: {
    border: `8px solid ${SUCCESS_COLORS[50]}`,
    background: SUCCESS_COLORS[100],
    color: SUCCESS_COLORS[600],
    margin: '0 auto'
  },
  uploadedContainer: {
    border: `1px solid ${GRAY_COLORS[100]}`,
    borderRadius: 8,
    padding: 8
  },
  labelWrapper: {
    backgroundColor: GRAY_COLORS[50],
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    padding: 8,
    height: 'fit-content',
    marginTop: 'auto'
  },
  label: {
    fontWeight: 600
  },
  input: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 99,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer'
  },
  img: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -1,
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  fileContainer: {
    flexDirection: 'column',
    padding: 24,
    border: `1px dashed ${PRIMARY_COLORS[400]}`,
    borderRadius: 8
  },
  placeholder: {
    fontWeight: 600,
    textAlign: 'center'
  },
  chipUpload: {
    backgroundColor: PRIMARY_COLORS[50],
    color: PRIMARY_COLORS[600],
    fontWeight: 500
  }
}))
